import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)

import PrivacyPolicy from '@/components/legal/PrivacyPolicy'
import TermsOfService from '@/components/legal/TermsOfService'
import Login from '@/components/auth/Login'
import Authorize from '@/components/auth/Authorize'
import Panel from '@/components/panel/Panel'
import GlobalPanel from '@/components/demo/GlobalPanel'

export default new Router({
  routes: [{
    path: '/',
    name: 'app_name',
    component: Panel,
    meta: {
      requiresAuth: true
    }
  }, {
    path: '/global',
    name: 'global_panel',
    component: GlobalPanel
  }, {
    path: '/login',
    name: 'login',
    component: Login
  }, {
    path: '/authorize',
    name: 'authorization',
    component: Authorize
  }, {
    path: '/privacy',
    name: 'privacy_policy',
    component: PrivacyPolicy
  }, {
    path: '/terms',
    name: 'terms_of_service',
    component: TermsOfService
  }],
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return {
        x: 0,
        y: 0
      }
    }
  }
})